import gql from 'graphql-tag';

export default gql`
 mutation Update($file: String, $path: String) {
  uploadFile(upload: { file: $file }, path: $path) {
   path
  }
 }
`;